import React from "react";
import { AnimatedNetworkBackground } from "./animated-network-background";

interface HeaderProps {
  data?: { title: string; paragraph: string };
}
export const Header: React.FC<HeaderProps> = ({ data }) => (
  <header
    id="header"
    className="relative isolate min-h-screen overflow-hidden bg-slate-950 bg-cover bg-center"
  >
    <AnimatedNetworkBackground />
    <div className="pointer-events-none absolute inset-0 z-10 bg-gradient-to-br from-slate-950/95 via-blue-950/85 to-slate-950/95" />
    {/* <div className="pointer-events-none absolute inset-0 z-10 bg-grid opacity-20" /> */}

    <div className="relative z-20 mx-auto flex min-h-screen max-w-6xl flex-col justify-center px-6 pb-20 pt-28 text-left lg:px-8 animate-fade-up">
      <div className="inline-flex w-fit items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-white/80 backdrop-blur">
        <span className="h-2 w-2 rounded-full bg-cyan-300 shadow" />
        Agentes de IA conectados à sua operação
      </div>
      <h1 className="mt-6 max-w-2xl text-4xl font-semibold leading-tight text-white sm:text-5xl lg:text-6xl">
        {data?.title ?? "Loading"}
      </h1>
      <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-100/90 sm:text-lg">
        {data?.paragraph ?? "Loading"}
      </p>
      <div className="mt-8 flex flex-col gap-4 sm:flex-row">
        <a
          href="#contato"
          className="inline-flex items-center justify-center rounded-full bg-blue-500 px-6 py-3 text-sm font-semibold text-white shadow-soft transition hover:bg-blue-400"
        >
          Agendar uma demonstração
        </a>
        <a
          href="#plataforma"
          className="inline-flex items-center justify-center rounded-full border border-white/40 px-6 py-3 text-sm font-semibold text-white transition hover:bg-white/10"
        >
          Conhecer a plataforma
        </a>
      </div>
      <div className="mt-10 flex flex-wrap gap-6 text-sm text-white/80">
        <div className="flex items-center gap-2">
          <span className="h-1.5 w-1.5 rounded-full bg-cyan-300" />
          Atendimento com IA e transferência para sua equipe
        </div>
        <div className="flex items-center gap-2">
          <span className="h-1.5 w-1.5 rounded-full bg-red-400" />
          Agendamentos, protocolos e acompanhamento
        </div>
        <div className="flex items-center gap-2">
          <span className="h-1.5 w-1.5 rounded-full bg-white/70" />
          Dashboards e histórico centralizado
        </div>
      </div>
    </div>
  </header>
);
